<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="rounded border col-lg-6 col-md-10" style=" padding: 3rem;background-color: white;">
            <h2>Reset Password</h2>
            <h6 class=" mt-2 mb-5">To set a new password, at first input your existing password.</h6>
            <!-- userType -->
            <div class="CurrentPassword" style="width: 50%;">
                <label for="currentPasswordControlInput" class="form-label">Current Password</label>
                <input type=password class="form-control currentPasswordInputField" id="currentPasswordControlInput"
                    @input="validateCurrentPassword" v-model="currentPassword" />
                <div v-if="currentPasswordError" class="text-danger">{{ currentPasswordErrorMessage }}</div>
            </div>
            <div class="CurrentPassword" style="width: 50%;">
                <label for="currentPasswordControlInput" class="form-label">Enter New Password</label>
                <input type=password class="form-control currentPasswordInputField" id="newPasswordControlInput"
                    @input="startValidation" v-model="newPassword" />
                <!-- @input="validateNewPassword" -->
                <div class="password-validation mb-2" v-if="hasUserStartedTyping">
                    <div v-if="passwordValidation.capitalLetter">
                        ✔️ Contains at least 1 capital letter
                    </div>
                    <div v-else>
                        ❌ Contains at least 1 capital letter
                    </div>
                    <div v-if="passwordValidation.smallLetter">
                        ✔️ Contains at least 1 small letter
                    </div>
                    <div v-else>
                        ❌ Contains at least 1 small letter
                    </div>
                    <div v-if="passwordValidation.specialChar">
                        ✔️ Contains at least 1 special character
                    </div>
                    <div v-else>
                        ❌ Contains at least 1 special character
                    </div>
                    <div v-if="passwordValidation.digit">
                        ✔️ Contains at least 1 digit
                    </div>
                    <div v-else>
                        ❌ Contains at least 1 digit
                    </div>
                    <div v-if="passwordValidation.length10">
                        ✔️ Minimum 10 characters long
                    </div>
                    <div v-else>
                        ❌ Minimum 10 characters long
                    </div>
                </div>

            </div>
            <div class="CurrentPassword" style="width: 50%;">
                <label for="currentPasswordControlInput" class="form-label">Re-enter New Password</label>
                <input type=password class="form-control currentPasswordInputField" id="reNewPasswordControlInput"
                    @input="validateReNewPassword" v-model="reNewPassword" />
                <div v-if="reNewPasswordError" class="text-danger">{{ reNewPasswordErrorMessage }}</div>
            </div>

            <div><button class="btn btn-dark" @click="checkPassword" style="margin-top: 16px;">
                    Confirm
                </button></div>
        </div>
    </div>
</template>

<script>
import userService from '@/services/user.service.js';
import UserService from '@/services/user.service.js';
import { notify } from "@kyvg/vue3-notification";

export default {
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Profile',
                    to: '/users/profile'
                }, {
                    text: 'Change Password',
                    href: '#'
                }
            ],
            user: [],
            userData: [],
            currentPassword: "",
            newPassword: "",
            reNewPassword: "",
            currentPasswordError: false,
            reNewPasswordError: false,
            currentPasswordErrorMessage: 'Please enter a valid current password.',
            newPasswordErrorMessage: 'Your password should contain at least 1 Capital Letter, 1 small letter, 1 special character and 1 digit. It\'s length should be 10 or more',
            reNewPasswordErrorMessage: 'Passwords do not match.',
            hasUserStartedTyping: false,
            passwordValidation: {
                specialChar: false,
                smallLetter: false,
                capitalLetter: false,
                digit: false,
                length10: false,
            },
        };
    },
    created() {
        this.getUserData();
    },
    methods: {

        async getUserData() {
            this.userData = await UserService.getUserById();

        },
        async checkPassword() {
            this.currentPassword = document.getElementById("currentPasswordControlInput").value;
            this.newPassword = document.getElementById("newPasswordControlInput").value;
            this.reNewPassword = document.getElementById("reNewPasswordControlInput").value;

            if (!this.validation(this.newPassword)) {
                // confirm("Invalid New Password!");
                notify({
                    type: "error",
                    title: "Wrong Input",
                    text: "Invalid New Password!",
                });
                return;
            }
            if (this.newPassword != this.reNewPassword) {
                // confirm("Passwords don't match!")
                notify({
                    type: "error",
                    title: "Wrong Input",
                    text: "Passwords don't match!",
                });
                return;
            }

            const data = {
                "oldPassword": this.currentPassword,
                "newPassword": this.newPassword,
            };

            const response = await userService.resetPassword(data);

            if (response.data.messageCode == 0) {
                notify({
                    type: "error",
                    title: "Unsuccessful",
                    text: response.data.message,
                });
            } else if (response.data.messageCode == 1) {
                notify({
                    type: "success",
                    title: "Successful",
                    text: response.data.message,
                });
                await new Promise(resolve => setTimeout(resolve, 2000));
                this.logOut();

            }
        },
        validation(password) {
            var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{10,30}$/;
            if (password.match(paswd)) {
                return true;
            } else {
                return false;
            }
        },

        validateCurrentPassword() {
            this.currentPassword = document.getElementById("currentPasswordControlInput").value;
            if (this.currentPassword == "") {
                this.currentPasswordError = true;
                this.currentPasswordErrorMessage = 'Please enter a valid current password.';
            } else if (!this.validation(this.currentPassword)) {
                this.currentPasswordError = true;
                this.currentPasswordErrorMessage = 'Please enter a valid current password.';
            } else {
                this.currentPasswordError = false;
                this.currentPasswordErrorMessage = '';
            }
        },
        startValidation() {
            this.hasUserStartedTyping = true;
            this.validatePassword();
        },
        validatePassword() {
            this.passwordValidation.specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword);
            this.passwordValidation.capitalLetter = /[A-Z]/.test(this.newPassword);
            this.passwordValidation.smallLetter = /[a-z]/.test(this.newPassword);
            this.passwordValidation.digit = /\d/.test(this.newPassword);
            this.passwordValidation.length10 = this.newPassword.length >= 10;
        },
        validateReNewPassword() {
            if (this.reNewPassword == "") {
                this.reNewPasswordError = true;
                this.reNewPasswordErrorMessage = 'Please enter a valid new password.';
            } else if (!this.validation(this.reNewPassword)) {
                this.reNewPasswordError = true;
                this.reNewPasswordErrorMessage = 'Please enter a valid new password.';
            } else if (this.newPassword != this.reNewPassword) {
                this.reNewPasswordError = true;
                this.reNewPasswordErrorMessage = 'Passwords do not match.';
            } else {
                this.reNewPasswordError = false;
                this.reNewPasswordErrorMessage = '';
            }
        },
        logOut() {
            this.$store.dispatch('auth/logout');
            //this.$router.push('/');
        }

    },

}


</script>
